import {ChangeFsanComponent} from './change-fsan/change-fsan.component';
import {UpdateFsanComponent} from './update-fsan/update-fsan.component';
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Product} from '../../../../../../../../models/interface/product/product';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ChangeCtoComponent} from './change-cto/change-cto.component';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {ProductDetailService} from '../../../../product-detail.service';
import {ValidateCtoComponent} from './validate-cto/validate-cto.component';
import {FtthService, IuaHistorical} from '../../../../../../../../services/api/ftth/ftth.service';
import {NotificationLevel, NotificationsService} from 'src/app/services/api/notifications/notifications.service';
import {TranslateService} from '@ngx-translate/core';
import {IuaHistoricalComponent} from './iua-historical/iua-historical.component';
import {CancelComponent} from '../../product-depth-level-product/product-depth-level-product-actions/cancel/cancel.component';
import {ActivateComponent} from '../../product-depth-level-product/product-depth-level-product-actions/activate/activate.component';
import {ChangeServiceComponent} from './change-service/change-service.component';
import {MoveCtoComponent} from './move-cto/move-cto.component';
import {CharValue} from 'src/app/models/interface/product/charValue';
import {Rfs} from 'src/app/models/interface/product/rfs';
import {AppService} from 'src/app/app.service';
import {ChangeCpeComponent} from './change-cpe/change-cpe.component';
import {ChangeOntPasswordComponent} from './change-ont-password/change-ont-password.component';
import { ConfirmationDialogComponent } from 'src/app/core/components/confirmation-dialog.component';
import { IpService } from 'src/app/services/api/ip/ip.service';
import { KeycloakService } from 'keycloak-angular';
import { Role } from 'src/app/utils/Role';


@Component({
  selector: 'app-product-depth-level-cfs-actions',
  templateUrl: './product-depth-level-cfs-actions.component.html',
  styleUrls: ['./product-depth-level-cfs-actions.component.scss']
})
export class ProductDepthLevelCfsActionsComponent implements OnInit, OnDestroy {

  @Input() item: Product;

  private serviceId: number;
  private type: string;
  private subscriptions = new Subscription();

  dialogActivateRef: MatDialogRef<ActivateComponent>;
  dialogCancelRef: MatDialogRef<CancelComponent>;

  cfsState: string;
  rfsState: string;

  territoryOwner: string;
  portalOwner: string;

  isWholesale: boolean;
  isAire: boolean = false;
  isOwnNetwork: boolean;
  hasChangeONTRole: boolean = false;
  canChangeONT = false;

  activeStates: string[] = ['ACTIVE','INSTALLED'];

  constructor(
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private productDetailService: ProductDetailService,
    private ftthService: FtthService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private appService: AppService,
    private ipService: IpService,
    public keycloakService: KeycloakService
  ) {
  }

  ngOnInit() {
    this.subscriptions.add(this.activatedRoute.queryParamMap.subscribe(params => {
      this.serviceId = +params.get('map');
      this.type = !params.get('type') ? 'product' : params.get('type');
      this.cfsState = this.item.cfses[0].serviceState;
      const rfs: Rfs = this.item.cfses[0].rfses.find((rfsItem) => rfsItem.specId.includes('Access'));
      this.rfsState = rfs ? rfs.serviceState : null;
      this.portalOwner = this.appService.settings.portalOwner;
      this.isWholesale = this.item.specId.includes('Wholesale');
      this.isAire = this.item.specId.includes('NEBA_Aire');
      this.hasChangeONTRole = this.keycloakService.getUserRoles().includes(Role.ChangePassword);
      this.canChangeONT = !this.isWholesale || (this.isWholesale && this.hasChangeONTRole);

      const territoryOwnerChar = this.item.cfses[0].cfsCharValues
        .find(serviceCharValue => serviceCharValue.specId === 'sc_network_territory_owner');
      if (territoryOwnerChar) {
        this.territoryOwner = territoryOwnerChar.value;
      } else {
        this.territoryOwner = this.portalOwner;
      }
      this.isOwnNetwork = (territoryOwnerChar.value === '001');
    }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  cancel() {
    this.dialogCancelRef = this.dialog.open(CancelComponent, {
      width: '850px',
      data: {
        idadministrativo: this.item.searchKey,
      }
    });
  }

  iuaHistorical() {
    this.ftthService.getIuaHistorical(this.item.origin, this.item.cfses[0].serviceId).subscribe(
      (data: IuaHistorical) => {
        this.dialog.open(IuaHistoricalComponent,
          {
            data: {
              historico: data.historicoadministrativos.idadmininstrativo,
            },
            restoreFocus: false,
            autoFocus: false
          });
      },
      () => {
        this.notificationsService.showNotification(this.translateService.instant('IUA_HISTORICAL.error'), NotificationLevel.ERROR);
      }
    );

  }

  changeCpe() {
    let cpeModel;
    let cpeMac;
    this.item.cfses[0].cfsCharValues.forEach((item) => {
      if (item.specId === 'sc_network_cpe_model') {
        cpeModel = item.value;
      } else if(item.specId === 'sc_network_cpe_mac') {
        cpeMac = item.value;
      }
    });

    const matDialogRef = this.dialog.open(ChangeCpeComponent,
      {
        data: {
          item: this.item,
          serviceId: this.item.cfses[0].serviceId,
          type: this.type,
          cpe: cpeModel,
          mac: cpeMac
        },
        disableClose: true,
        hasBackdrop: true,
        width: '70%',
        maxHeight: '70%',
        restoreFocus: false,
        autoFocus: false
      });

    this.subscriptions.add(matDialogRef.afterClosed()
      .pipe(
        filter(result => !!result)
      )
      .subscribe(() => {
        this.productDetailService.reload();
      }));
  }

  changeCto() {
    const ino = this.territoryOwner;
    const matDialogRef = this.dialog.open(ChangeCtoComponent,
      {
        data: {
          item: this.item,
          serviceId: this.serviceId,
          type: this.type,
          ino
        },
        disableClose: true,
        hasBackdrop: true,
        width: '70%',
        maxHeight: '70%',
        restoreFocus: false,
        autoFocus: false
      });

    this.subscriptions.add(matDialogRef.afterClosed()
      .pipe(
        filter(result => !!result)
      )
      .subscribe(() => {
        this.productDetailService.reload();
      }));
  }

  moveCtoAndReprovision() {
    const matDialogRef = this.dialog.open(MoveCtoComponent,
      {
        data: {
          item: this.item,
          type: this.type
        },
        disableClose: true,
        hasBackdrop: true,
        width: '70%',
        maxHeight: '70%',
        restoreFocus: false,
        autoFocus: false
      });

    this.subscriptions.add(matDialogRef.afterClosed()
      .pipe(
        filter(result => !!result)
      )
      .subscribe(() => {
        this.productDetailService.reload();
      }));
  }

  test() {
    const ino = this.territoryOwner;
    this.dialog.open(ValidateCtoComponent,
      {
        data: {
          item: this.item,
          serviceId: this.serviceId,
          type: this.type,
          ino
        },
        restoreFocus: false,
        autoFocus: false
      });
  }

  private reprovision() {
    const reprovisionDto = {
      iua: this.item.cfses[0].serviceId,
      pfiRequired: true,
      acsRequired: false,
      msmRequired: false
    };
    this.ipService.reprovision(reprovisionDto).subscribe(
      (data: any) => {
        if (data && data.resultado !== 'NOK' && data.resultado !== 'KO') {
          this.notificationsService.showNotification(this.translateService.instant('IP_LIST.reprovision_ok_wholesale'), NotificationLevel.SUCCESS);
          this.productDetailService.reload();
        }
        else if (data) {
          this.notificationsService.showNotification("ERROR (" + data.codResultado + "): " + data.descResultado, NotificationLevel.ERROR);
        }
        else {
          this.notificationsService.showNotification(this.translateService.instant('IP_LIST.reprovision_error'), NotificationLevel.ERROR);
        }
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('IP_LIST.reprovision_error'), NotificationLevel.ERROR);
      }
    );
  }

  public confirmReprovision(){
    const stateDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        text: 'Se lanzará una reprovisión. ¿Desea continuar?',
      },
      disableClose: true,
      minWidth: 150,
      minHeight: 150,
    });

    stateDialog.afterClosed().subscribe((value) => {
      if(value){
        this.reprovision();
      }
    });
  }

  changeService() {
    const matDialogRef = this.dialog.open(ChangeServiceComponent,
      {
        data: {
          item: this.item,
          type: this.type,
        },
        disableClose: true,
        minWidth: '500px',
        restoreFocus: false,
        autoFocus: false
      });

    this.subscriptions.add(matDialogRef.afterClosed()
      .pipe(
        filter(result => !!result)
      )
      .subscribe(() => {
        this.productDetailService.reload();
      }));
  }

  changeFSAN() {
    const matDialogRef = this.dialog.open(ChangeFsanComponent, {
      data: {
        item: this.item,
        serviceId: this.item.cfses[0].serviceId,
        type: this.type,
        fsan: this.findFsan().value
      },
      disableClose: true,
      hasBackdrop: true,
      width: '70%',
      maxHeight: '70%',
      restoreFocus: false,
      autoFocus: false
    });

    this.subscriptions.add(matDialogRef.afterClosed()
      .pipe(
        filter(result => !!result)
      )
      .subscribe(() => {
        this.productDetailService.reload();
      }));
  }

  updateFSAN() {
    const matDialogRef = this.dialog.open(UpdateFsanComponent, {
      data: {
        item: this.item,
        serviceId: this.item.cfses[0].serviceId,
        type: this.type,
        fsan: this.findFsan().value
      },
      disableClose: true,
      hasBackdrop: true,
      width: '70%',
      maxHeight: '70%',
      restoreFocus: false,
      autoFocus: false
    });

    this.subscriptions.add(matDialogRef.afterClosed()
      .pipe(
        filter(result => !!result)
      )
      .subscribe(() => {
        this.productDetailService.reload();
      }));
  }

  changeOntPassword() {
    const matDialogRef = this.dialog.open(ChangeOntPasswordComponent, {
      data: {
        item: this.item,
        serviceId: this.item.cfses[0].serviceId,
        type: this.type,
        ontPassword: this.findOntPassword().value
      },
      disableClose: true,
      hasBackdrop: true,
      width: '70%',
      maxHeight: '70%',
      restoreFocus: false,
      autoFocus: false
    });

    this.subscriptions.add(matDialogRef.afterClosed()
      .pipe(
        filter(result => !!result)
      )
      .subscribe(() => {
        this.productDetailService.reload();
      }));
  }

  isFSANProvisionType(): boolean {
    const provisionType = this.getProvisionType();
    return provisionType && provisionType.value === 'FSAN';
  }
  
  getProvisionType(): CharValue {
    return this.item.cfses[0].cfsCharValues.find(characteristic => characteristic.specId === 'sc_network_provision_type');
  }

  findFsan(): CharValue {
    return this.item.cfses[0].cfsCharValues.find(characteristic => characteristic.specId === 'sc_network_fsan');
  }

  findOntPassword(): CharValue {
    return this.item.cfses[0].cfsCharValues.find(characteristic => characteristic.specId === 'sc_network_ont_password');
  }

}
